import throttle from 'lodash.throttle';


export class ActivityMonitor {
    onActivity;

    idle = true;

    idleTimer;

    idleTimeoutSeconds;

    activityEvents;

    constructor({
      onActivity,
      idleTimeoutSeconds = 5,
      activityEvents = ['mousedown', 'keydown', 'scroll', 'mousemove', 'resize'],
    }) {
      this.onActivity = onActivity;
      this.idleTimeoutSeconds = idleTimeoutSeconds;
      this.activityEvents = activityEvents;
    }

    start = () => {
      this.activityEvents.forEach(evt => {
        this._addEventListener(evt, this.pulse);
      });
    };

    stop = () => {
      this.activityEvents.forEach(evt => {
        this._removeEventListener(evt, this.pulse);
      });
    };

    pulse = () => {
      window.clearTimeout(this.idleTimer);
      if (this.idle) {
        this.idle = false;
      }
      this.idleTimer = window.setTimeout(this._setIdle, this.idleTimeoutSeconds * 1000);

      if (typeof (this.onActivity) === 'function') {
        throttle(this.onActivity, 5000, {leading: true, trailing: true});
      }
    };

    _addEventListener = (evt, cb) => {
      if (window.addEventListener) {
        window.addEventListener(evt, cb);
      } else if (window.attachEvent) {
        window.attachEvent(`on${evt}`, cb);
      }
    };

    _removeEventListener = (evt, cb) => {
      if (window.removeEventListener) {
        window.removeEventListener(evt, cb);
      } else if (window.detachEvent) {
        window.detachEvent(evt, cb);
      }
    };

    _setIdle = () => {
      this.idle = true;
    }
}
